import { Hidden } from '@material-ui/core'
import ArrowRightRoundedIcon from '@material-ui/icons/ArrowRightRounded'
import { Link } from 'react-router-dom'
import getStarted from '../../Assets/layout_images/getStarted.png'
import step1 from '../../Assets/layout_images/step1.png'
import step2 from '../../Assets/layout_images/step2.png'
import step3 from '../../Assets/layout_images/step3.png'
import step4 from '../../Assets/layout_images/step4.png'
import step5 from '../../Assets/layout_images/step5.png'
import step6 from '../../Assets/layout_images/step6.png'
import step7 from '../../Assets/layout_images/step7.png'

export default function Steps({ type, color }) {
    const points = [     
        {
            title : "Tutor Selection",
            content:  "Every student begins by selecting an "+type+" tutor who best fits their learning style.✨Focusing on a student's pace, basics, \
            friendliness, and teaching approach.",
            image:step1,
            backgroud:"#bbdcef"
        },
        {
            title : "Personalized Timetable",
            content: "We create a custom tuition time-table, balanced.✨Considering school timings, meal times, and extracurricular activities.",
            image:step2,
            backgroud:"#ffe9e8"
        },
        {
            title : "Session Management",
            content: "Need to reschedule or have a concern? ✨Our counselors are always just a message away.",
            image:step3,
            backgroud:"#bde1f7"
        },
        {
            title : "Hybrid AI Exams",
            content: "Every 15 days, students take a unit test via our Hybrid AI Exam Tool, covering recent lessons.\
            ✨We assess both knowledge depth and learning comfort across three levels of difficulty.\
            ✨If weak areas are found, students can retake targeted exams until they master them.",
            image:step7,
            backgroud:"#d1edd9"
        },
        {
            title : "Real-Time Progress Tracking",
            content: "Parents get full visibility through the teacherInd Parent Portal.\
            ✨Track growth, topic mastery, and marks at tuition and school exams.",
            image:step5,
            backgroud:"#fedce4"
        },
        {
            title : "Monthly Growth Sessions",
            content: "We go beyond academics with counseling sessions every month.\
            ✨ Students are guided on emotional",
            image:step6,
            backgroud:"#bee2f8"
        }
    ]

    function makesteps() {
        return (
            <>
            {points.map((el, key) => (
                <div className="steps" key={key} style={{backgroundColor:el.backgroud}}>
                    <div className='steps-content'>
                        <div>
                        <h2 className='font-Quick font-semi'>{el.title}</h2>
                        <p className='font-Quick font-med step-content-text'>{el.content}</p>
                        <div className={`get_started_button_${type}`}>
                            <Link
                                className={`${type}_book_button font-Quick font-bold`}
                                to="/form"
                            >
                                Book Now
                            </Link>
                        </div>
                        </div>
                    </div>
                    <div className='steps-image' style={{backgroundImage:`url(${el.image})`,backgroundSize:"contain",backgroundPosition:"center",backgroundRepeat:'no-repeat'}}>
                        {/* <img src={step1} /> */}
                        <div className='image-overlay' style={{background: `linear-gradient(90deg, ${el.backgroud}, transparent)`,}}></div>
                    </div>
                </div>
            ))}
            </>
        )
    }

    function heading() {
        return <h2 className="font-Quick font-semi"></h2>
    }

    return (
        <div
            className={`${type}_how_to_get_started_section how_to_get_started_section`}
        >
                <h2 className="font-Quick font-semi" style={{textAlign:"center",color:'#0874f5'}}>
                How It Works ?
                </h2>
                <h4 className="font-Quick font-semi" style={{textAlign:"center"}}>
                We Help Your Child Earn Better Marks In 6 Steps

                </h4>
            <Hidden mdUp>
                <div
                    className={`${type}_how_to_get_started_section_mob how_to_get_started_section_mob`}
                >
                    {heading()}
                    <div>
                        {makesteps()}
                    </div>
                </div>
            </Hidden>
            <Hidden smDown>
                <div
                    className={`${type}_how_to_get_started_section_desk how_to_get_started_section_desk`}
                >
                    
                    {/* <img src={getStarted} alt="getStarted" /> */}
                    <div>
                        {heading()}
                        {makesteps()}

                        
                    </div>
                </div>
            </Hidden>
        </div>
    )
}
